<button
  type="button"
  class="py-1 border border-gray-300 rounded transition-all duration-200 cursor-pointer min-w-19 text-gray-700 text-xs focus:outline-none focus:ring-1 focus:ring-amazone-orange"
  (click)="toggleState()"
  [ngClass]="{
    'bg-diff-added': state === true,
    'bg-diff-removed': state === false,
    'bg-gray-50': state == undefined,
  }"
  [disabled]="disabled"
>
  {{ state === true ? textTrue : state === false ? textFalse : textNull }}
</button>
